import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';

export default function AuthPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('test@testdomene.no');
  const [password, setPassword] = useState('Admin123');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const success = await login(email, password);

      if (success) {
        // Redirect to home after successful login
        navigate('/');
      } else {
        setError('Ugyldig e-post eller passord. Prøv igjen.');
      }
    } catch (err: any) {
      console.error('Auth error:', err);
      setError('Noe gikk galt. Prøv igjen.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-full max-w-md p-8 space-y-6">
        <div className="text-center">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img
              src="/logo/frame.png"
              alt="Findr Logo"
              width={120}
              height={120}
            />
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium mb-2">
              E-postadresse
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="test@testdomene.no"
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900 bg-white"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium mb-2">
              Passord
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Admin123"
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900 bg-white"
            />
          </div>

          {error && (
            <div className="p-3 text-sm text-red-600 bg-red-50 rounded-lg">
              {error}
            </div>
          )}

          <Button type="submit" className="w-full" disabled={isLoading}>
            {isLoading ? 'Logger inn...' : 'Logg inn'}
          </Button>
        </form>

        <div className="text-center pt-6 space-y-3">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t" style={{ borderColor: 'var(--color-border)' }}></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span style={{ color: 'var(--color-text-secondary)', backgroundColor: 'var(--color-bg-primary)', padding: '0 var(--space-md)' }}>
                eller
              </span>
            </div>
          </div>
          <div>
            <p style={{ fontSize: 'var(--font-size-body-md)', color: 'var(--color-text-secondary)', marginBottom: 'var(--space-md)' }}>
              Har du ikke konto ennå?
            </p>
            <Button
              type="button"
              variant="outline"
              onClick={() => navigate('/register')}
              className="w-full"
            >
              Opprett ny konto
            </Button>
          </div>
        </div>

        <div className="text-center text-sm text-gray-500 pt-4 border-t">
          <p className="font-medium mb-2">Hardkodede test-brukere:</p>
          <div className="space-y-1">
            <button
              type="button"
              onClick={() => {
                setEmail('test@testdomene.no');
                setPassword('Admin123');
              }}
              className="block w-full text-left px-3 py-2 rounded hover:bg-gray-100 transition-colors"
            >
              <strong>Jobbsøker:</strong> test@testdomene.no / Admin123
            </button>
            <button
              type="button"
              onClick={() => {
                setEmail('employer@testdomene.no');
                setPassword('Admin123');
              }}
              className="block w-full text-left px-3 py-2 rounded hover:bg-gray-100 transition-colors"
            >
              <strong>Arbeidsgiver:</strong> employer@testdomene.no / Admin123
            </button>
          </div>
        </div>

        {/* Terms and Privacy */}
        <div className="text-center pt-4">
          <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
            Ved å logge deg inn eller registrere deg godtar du våre{' '}
            <a href="/terms" className="underline" style={{ color: 'var(--color-text-primary)' }}>
              Brukervilkår
            </a>
            {' '}og{' '}
            <a href="/privacy" className="underline" style={{ color: 'var(--color-text-primary)' }}>
              Personvernerklæring
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

